// extracted by mini-css-extract-plugin
export default {"footer":"ConfirmationModal__footer___H2hWC"};